import { useTranslation } from 'react-i18next';
import { AlertTriangle, TrendingUp, Gauge } from 'lucide-react';
import './BottleneckCards.css';

const DIMENSION_ICON = {
  task: TrendingUp,
  product: Gauge,
  rework: AlertTriangle,
};

function BottleneckCard({ item, t }) {
  const Icon = DIMENSION_ICON[item.dimension] || Gauge;
  const severityLabel = t(`bottlenecks.severity.${item.severity}`, {
    defaultValue: t('bottlenecks.severity.fallback'),
  });
  return (
    <div className={`bn-card bn-card-${item.severity}`}>
      <div className="bn-card-top">
        <span className={`bn-sev-badge bn-sev-${item.severity}`}>
          <Icon size={11} aria-hidden="true" />
          {severityLabel}
        </span>
        {item.metric && <span className="bn-metric">{item.metric}</span>}
      </div>
      <span className="bn-title">{item.title}</span>
      <p className="bn-body">{item.body}</p>
      {item.action && <p className="bn-action">{item.action}</p>}
    </div>
  );
}

/**
 * Bottleneck Detection panel for the admin dashboard.
 *
 * @param {object[]} bottlenecks - prioritised list from detectBottlenecks()
 * @param {boolean}  hasEnoughData - false when there are too few completed runs
 */
export default function BottleneckCards({ bottlenecks, hasEnoughData }) {
  const { t } = useTranslation();

  if (!hasEnoughData) {
    return (
      <div className="bn-section">
        <div className="bn-section-label">
          <Gauge size={11} aria-hidden="true" />
          {t('bottlenecks.sectionTitle')}
        </div>
        <div className="bn-empty">
          {t('bottlenecks.notEnoughData')}
        </div>
      </div>
    );
  }

  if (!bottlenecks?.length) {
    return (
      <div className="bn-section">
        <div className="bn-section-label">
          <Gauge size={11} aria-hidden="true" />
          {t('bottlenecks.sectionTitle')}
        </div>
        <div className="bn-empty bn-empty-clear">
          {t('bottlenecks.noBottlenecks')}
        </div>
      </div>
    );
  }

  return (
    <div className="bn-section">
      <div className="bn-section-label">
        <Gauge size={11} aria-hidden="true" />
        {t('bottlenecks.sectionTitle')}
        <span className="bn-section-sub">{t('bottlenecks.sectionSub')}</span>
      </div>
      <div className="bn-grid">
        {bottlenecks.map((item) => (
          <BottleneckCard key={item.id} item={item} t={t} />
        ))}
      </div>
    </div>
  );
}
